export default __webpack_public_path__ + "static/media/sub-banner.d8362afa.png";